import DisciplineDTO from './DisciplineDTO.js';
import TeamDTO from './TeamDTO.js';

class PlayerDTO {
    constructor(playerData) {
        if (!playerData || Object.keys(playerData).length === 0) return;

        const {
        _id,
        lastname,
        firstname,
        fullname,
        birthdate,
        nationality,
        department,
        additionalInfo,
        teams,
        disciplines,
        provider,
        team_id,
        } = playerData;

        this._id = _id;
        this.lastname = lastname;
        this.firstname = firstname;
        this.fullname = fullname;
        this.birthdate = birthdate;
        this.nationality = nationality;
        this.department = department;
        this.additionalInfo = additionalInfo;

        this.disciplines = disciplines
        ?.filter(discipline => discipline && Object.keys(discipline).length > 0)
        .map(discipline => new DisciplineDTO(discipline));

        this.teams = teams
        ?.filter(team => team && Object.keys(team).length > 0)
        .map(team => new TeamDTO(team));

        this.team_id = team_id?.trim() || undefined;
        this.provider = provider?.trim();
    }
}

export default PlayerDTO;